import React from "react";
import { Loader2 } from "lucide-react";

export default function PageLoading({ label }) {
  return (
    <div className="brand-grad flex min-h-screen min-h-[100dvh] items-center justify-center px-5" data-testid="page-loading">
      <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-6 py-5 text-[#0F4C5C] shadow-[0_2px_12px_rgba(15,76,92,0.08)]" role="status" aria-live="polite">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#2A9D8F]/10">
          <Loader2 className="h-6 w-6 animate-spin text-[#2A9D8F]" aria-hidden="true" />
        </span>
        <span className="font-head text-base font-semibold">{label}</span>
      </div>
    </div>
  );
}
